import { render, staticRenderFns } from "./People.vue?vue&type=template&id=4459b04f&"
import script from "./People.vue?vue&type=script&lang=ts&"
export * from "./People.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports